import { BOGO_OFFER_FLAG_NAME } from '@mc/bogo-utils'
import {
  EventTypes,
  Locations,
  NavigationEvents,
  Pages,
  ProductLine,
  segment,
  track,
  trackExperimentViewed,
  trackGoldStandardEvent,
} from '@mc/track-event'
import type { BogoOfferSurfaceName } from './types'
import {
  incrementBogoOfferViewCountCookie,
  getBogoOfferViewCountCookie,
  incrementBogoOfferAcknowledgeCountCookie,
  getBogoOfferAcknowledgeCountCookie,
} from './utils'

export const trackTooltipView = () =>
  track(EventTypes.TOOLTIP_VIEWED, {
    subscription_id: {},
    active_annual_pass: false,
    category: 'send gift reminder',
    location: Locations.PROMOTION_TOOLTIP,
    page_source: Pages.HOME_PAGE,
    product: ProductLine.MASTERCLASS,
  })

export const trackNavigationClicked = ({
  action = segment.Actions.DISMISS,
  location = segment.Locations.PROMOTION_BANNER,
}: {
  action?: string
  location?: string
} = {}) => {
  trackGoldStandardEvent(NavigationEvents.EVENTS.NAVIGATION_CLICKED, {
    subscription_id: {},
    active_annual_pass: false,
    location,
    action,
  })
}

export const trackBogoExperimentViewed = () =>
  trackExperimentViewed(BOGO_OFFER_FLAG_NAME)

export const trackOfferViewed = (surfaceName: BogoOfferSurfaceName) => {
  incrementBogoOfferViewCountCookie(surfaceName)
  track('Offer Viewed', getBogoOfferViewCountCookie())
}

export const trackOfferAcknowledged = (surfaceName: BogoOfferSurfaceName) => {
  incrementBogoOfferAcknowledgeCountCookie(surfaceName)
  track('Offer Acknowledged', getBogoOfferAcknowledgeCountCookie())
}
